import { generatePath } from 'react-router';

import type { AgentCoreMessageContext } from '@/shared/api/agentCore/agentCoreApi';
import {
  ReportType,
  type Report,
} from '@/shared/api/protocol-ts/model/dto_report_pb';
import { buildTemplatesUrl, getSegmentronReportLink } from '@/shared/lib';

import { getReportPath } from '@/entities/reports';

export const getMessageResourceLink = (
  resource: AgentCoreMessageContext['resources'][number],
  context: AgentCoreMessageContext,
  report?: Report,
) => {
  const id = encodeURIComponent(resource.id);
  const patientID = encodeURIComponent(context.patient_id || '');
  const patientPath = `/patients/${patientID}`;
  switch (resource.type) {
    case 'patient':
      return `/patients/${id}`;
    case 'report': {
      if (!patientID) return undefined;
      if (
        report &&
        [
          ReportType.ReportType_CBCT_Segmentation,
          ReportType.ReportType_CBCT_IOS_Superimposition,
          ReportType.ReportType_IOS_Segmentation,
          ReportType.ReportType_StudioImplant,
          ReportType.ReportType_StudioOrtho,
        ].includes(report.Type)
      ) {
        return getSegmentronReportLink(report.ID, report.Type);
      }
      const path = report && getReportPath(report.Type);
      return path
        ? generatePath(path, { patientID, reportID: id })
        : `${patientPath}/preview2d/${id}`;
    }
    case 'document':
      return patientID ? `${patientPath}/documents/${id}` : undefined;
    case 'consultation':
      return patientID
        ? `${patientPath}/reports/consultation?id=${id}`
        : undefined;
    case 'encounter':
      return `/encounters/${id}`;
    case 'tooth': {
      const parentReport = context.resources.find(
        (item) => item.type === 'report',
      );
      return patientID && parentReport
        ? `${patientPath}/reports/${encodeURIComponent(parentReport.id)}/gp/tooth/${id}`
        : undefined;
    }
    case 'document-template':
      return buildTemplatesUrl({
        editor: 'document',
        mode: 'edit',
        id: resource.id,
      });
    case 'encounter-schema':
      return buildTemplatesUrl({
        editor: 'schema',
        mode: 'edit',
        id: resource.id,
      });
    case 'document-template-series':
      return buildTemplatesUrl({ importedTemplateSeriesId: resource.id });
    default:
      return undefined;
  }
};
